<div>
    <h2 mat-dialog-title class="text-lg font-bold mb-1">{{ getDialogTitle() }}</h2>
    <mat-dialog-content class="modal-content">
        <form class="form">
            <div class="grid grid-cols-2 gap-y-2 gap-x-4">
                <div class="form-group col-md-12">
                    <div>
                        <span>{{ getProcessText() }}</span>
                    </div>
                    <mat-form-field appearance="fill" class="w-full" floatLabel="never">
                        <mat-select [(ngModel)]="selectOption" name="tipo" (selectionChange)="onSelectOption($event.value)">
                            <mat-option *ngIf="this.data.requeriment && this.data.requeriment.approve" [value]="'A'">Aprobar</mat-option>
                            <mat-option *ngIf="this.data.requeriment && this.data.requeriment.approve_generate" [value]="'D'">Aprobar y Generar Siguiente Documento</mat-option>
                            <mat-option *ngIf="this.data.requeriment && this.data.requeriment.reject" [value]="'R'">Rechazar</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
    
                <mat-form-field *ngIf="this.selectOption == 'A' && this.data.type == TypeRejectEnum.SOLICITUD_CREDITO" appearance="fill" class="col-span-1">
                    <mat-label>Cantidad a aprobar</mat-label>
                    <input matInput type="number" [(ngModel)]="quantityCredit" name="quantityCredit" [max]="this.data.element.amountCreditRequested"
                    (input)="validateQuantity()">
                </mat-form-field>

                <mat-form-field *ngIf="this.data.requeriment && this.data.requeriment.approve_generate && this.selectOption == 'D'" class="col-span-1">
                    <mat-label>Clase de documento</mat-label>
                    <mat-select [(ngModel)]="documentClassId" name="documentClassId">
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchDocumentClass"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="changueOptionDocumentClasses($event)"
                                placeholderLabel="Buscar..."
                                noEntriesFoundLabel="No se encontraron resultados">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let reasonRejection of filteredDocumentClassesApproveList"
                            [value]="reasonRejection._id">
                            {{ reasonRejection.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field *ngIf="this.selectOption != 'D'" [ngClass]="this.selectOption == 'A' && this.data.type == TypeRejectEnum.SOLICITUD_CREDITO ? 'col-span-2' : 'col-span-1'">
                    <mat-label>Motivo de rechazo</mat-label>
                    <mat-select [(ngModel)]="reasonRejectionId" name="reasonRejectionId" [disabled]="!showRejection">
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchReasonRejection"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="changueOptionRejection($event)"
                                placeholderLabel="Buscar..."
                                noEntriesFoundLabel="No se encontraron resultados">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let reasonRejection of filteredReasonRejectionList"
                            [value]="reasonRejection._id">
                            {{ reasonRejection.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field *ngIf="isTypeConditional" class="col-span-2">
                    <mat-label>Ingrese un comentario</mat-label>
                    <textarea matInput [(ngModel)]="comment" name="comment" cdkTextareaAutosize #autosize="cdkTextareaAutosize" 
                    cdkAutosizeMaxRows="2" [disabled]="!showComment"></textarea>
                </mat-form-field>
            </div>
        
            <mat-dialog-actions class="modal-actions flex justify-end">
                <button mat-button (click)="onClose()" class="align-left">
                    Cancelar
                </button>
                <button mat-raised-button color="primary" (click)="openConfirmDialog()">
                    Guardar
                </button>
            </mat-dialog-actions>
        </form>
    </mat-dialog-content>
</div>

<ng-template #confirmDialog let-data>
    <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
            <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
                style="font-size: 32px"></mat-icon>
        </div>
        <div class="grid">
            <h2 mat-dialog-title class="text-lg font-bold mb-1">
                Confirmar registro
            </h2>
            <mat-dialog-content class="modal-content mt-0">
                <p>¿Está seguro de aprobar/rechazar el registro?</p>
            </mat-dialog-content>
        </div>
    </div>
    <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">
            Conservar
        </button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">
            Aceptar
        </button>
    </mat-dialog-actions>
</ng-template>